module.exports = __webpack_public_path__ + "static/media/error-img.e00b5b16.png";